/**
 * Single source of truth for an affiliate's referral link (Eric's ruling on the
 * promo-resources ticket: the Settings referral field, the dashboard copy-link
 * button, and the QR code must all read the IDENTICAL string from one helper).
 *
 * Encodes the VERBATIM username — backend username lookups are case-sensitive
 * and usernames are stored as registered; the /elite resolver tolerates any
 * casing, but the canonical shared string is the username exactly as returned
 * by auth/me. Never lowercase here.
 */
export const getReferralUrl = (username: string): string =>
  `https://trademagic.gg/elite/${username}`;
